import { CostCalculationExternal } from 'generated';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import HoursDisplay from 'components/shared/cell-formatters/HoursDisplay';
import MonetaryDisplay from 'components/shared/cell-formatters/MonetaryDisplay';
import { GridCompact1 } from 'components/shared/Grid/Grid.components';

const months = {
  1: 'january',
  2: 'february',
  3: 'march',
  4: 'april',
  5: 'may',
  6: 'june',
  7: 'july',
  8: 'august',
  9: 'september',
  10: 'october',
  11: 'november',
  12: 'december'
};

type CostCalculationExternalYearProperties = {
  records: CostCalculationExternal[];
};

export default function CostCalculationExternalYear(
  properties: CostCalculationExternalYearProperties
) {
  const monthRecords = properties.records;
  const { t } = useTranslation('common');

  return (
    <>
      <Grid
        container
        mt={2}
        style={{
          fontFamily: "'SourceSansPro-Regular', Arial, Helvetica, 'sans-serif'",
          backgroundColor: '#EEEEEE'
        }}
      >
        <GridCompact1>{t('month')}</GridCompact1>
        <GridCompact1 textAlign="right">{t('hours')}</GridCompact1>
        <GridCompact1 textAlign="right">{t('km')}</GridCompact1>
        <GridCompact1 textAlign="right">{t('totalHours')}</GridCompact1>
        <GridCompact1 textAlign="right">{t('totalFees')}</GridCompact1>
        <GridCompact1 textAlign="right">
          {t('totalTravelExpenses')}
        </GridCompact1>
        <GridCompact1 textAlign="right">{t('totalVat')}</GridCompact1>
        <GridCompact1 textAlign="right">{t('total')}</GridCompact1>
      </Grid>
      <Grid borderBottom={1}>
        {monthRecords.map((monthRecord, index) => (
          <Grid container key={index}>
            <GridCompact1>
              {t(`monthnames.${months[monthRecord.month]}`)}
            </GridCompact1>
            <GridCompact1>
              <HoursDisplay
                value={monthRecord.hours
                  .map((h) => h.hours)
                  .reduce((a, b) => a + b, 0)}
              />
            </GridCompact1>
            <GridCompact1>
              <HoursDisplay value={monthRecord.totalKm} />
            </GridCompact1>
            <GridCompact1>
              <MonetaryDisplay value={monthRecord.totalHours} />
            </GridCompact1>
            <GridCompact1>
              <MonetaryDisplay value={monthRecord.totalFees} />
            </GridCompact1>
            <GridCompact1>
              <MonetaryDisplay value={monthRecord.totalTravelExpenses} />
            </GridCompact1>
            <GridCompact1>
              <MonetaryDisplay value={monthRecord.totalVat} />
            </GridCompact1>
            <GridCompact1>
              <MonetaryDisplay value={monthRecord.total} />
            </GridCompact1>
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        mt={1}
        style={{
          fontFamily: "'SourceSansPro-Regular', Arial, Helvetica, 'sans-serif'",
          backgroundColor: '#CCCCCC'
        }}
      >
        <GridCompact1>{t('totals')}</GridCompact1>
        <GridCompact1>
          <HoursDisplay
            value={monthRecords
              .map((monthRecord) =>
                monthRecord.hours.map((h) => h.hours).reduce((a, b) => a + b, 0)
              )
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <HoursDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalKm)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalHours)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalFees)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalTravelExpenses)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalVat)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
        <GridCompact1>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.total)
              .reduce((a, b) => a + b, 0)}
          />
        </GridCompact1>
      </Grid>
    </>
  );
}
